module.exports = __webpack_public_path__ + "static/aboutsandy-credential-pci-min-ca885b03dfa7d485cccb4bef782a6061.png";